import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "window" }
const _hoisted_2 = {
  key: 0,
  class: "header-modal",
  style: {}
}
const _hoisted_3 = {
  key: 0,
  class: "icon",
  style: {"display":"flex","padding-right":"10px"}
}
const _hoisted_4 = {
  key: 0,
  class: "icon-icon_error"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "icon-icon_warning"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "icon-icon_info"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "body" }
const _hoisted_19 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_ctx.innerVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ui-modal-window",
        id: "modal-wrapper",
        onMouseup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mouseUpWrapper && _ctx.mouseUpWrapper(...args))),
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseDownWrapper && _ctx.mouseDownWrapper(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.showHeaderTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _createElementVNode("div", {
                    class: "name-modal",
                    style: _normalizeStyle({ justifyContent: _ctx.titleJustify })
                  }, [
                    (_ctx.icon)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_ctx.type == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_8))
                            : _createCommentVNode("", true),
                          (_ctx.type == 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_12))
                            : _createCommentVNode("", true),
                          (_ctx.type == 4)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_17))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "title",
                      style: _normalizeStyle({ marginLeft: _ctx.titleMarginLeft })
                    }, _toDisplayString(_ctx.title), 5),
                    _renderSlot(_ctx.$slots, "togle")
                  ], 4)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _renderSlot(_ctx.$slots, "default"),
            (!_ctx.noButton)
              ? _renderSlot(_ctx.$slots, "button", { key: 0 }, () => [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", {
                      class: "button-wrapper",
                      style: _normalizeStyle({ justifyContent: _ctx.buttonsJustify })
                    }, [
                      (_ctx.showCloseBtn)
                        ? (_openBlock(), _createBlock(_component_ui_button, {
                            key: 0,
                            onOnClick: _ctx.onCancel,
                            width: 100,
                            tabindex: '101',
                            class: "ui_modal_window_button_cancel"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.titleBtnNo), 1)
                            ]),
                            _: 1
                          }, 8, ["onOnClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.showOkBtn)
                        ? (_openBlock(), _createBlock(_component_ui_button, {
                            key: 1,
                            onOnClick: _ctx.onOk,
                            width: 100,
                            active: "",
                            tabindex: '102',
                            style: {"margin-right":"5px"},
                            class: "ui_modal_window_button_ok"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.titleBtnYes), 1)
                            ]),
                            _: 1
                          }, 8, ["onOnClick"]))
                        : _createCommentVNode("", true)
                    ], 4)
                  ])
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ], 32))
    : _createCommentVNode("", true)
}